import * as actions from './actions'
import reducer from './reducer'
import OkReportDeveloperForm from './components/OkReportDeveloperForm'
import * as TypeAction from './actionTypes'



const config = {
    route: {
        path: '/OkReportDeveloperForm',
        exact: true,
        component: OkReportDeveloperForm,
        permissao: "Personalizar.Elaborar Relatório"
    },
    menu: { nome: "Elaborar Relatorio", rota: '/OkReportDeveloperForm', ordem: 900, subDe:"Personalizar", permissao: "Personalizar.Elaborar Relatório" },
    reducerConfig: { nome: "OkReportReducer", reducer: reducer }

}

export default config


export { actions, reducer, TypeAction }




// WEBPACK FOOTER //
// ./src/routes/sistema/OkReportDeveloper/index.js